import React from 'react';
import {Typography,Grid} from '@material-ui/core';
import IntlMessages from 'util/IntlMessages';
function Kund(props) {
    console.log(props)
    return (
        <Grid container className="px-5">
            <Grid md="12">
            <h2><IntlMessages id="Table.Customer"/></h2>
            </Grid>      
            <Grid sm="2"><Typography><IntlMessages id="Customer.Name"/>:</Typography></Grid>      
            <Grid sm="10">
                <Typography>{props.currentKund.AF_kundnamn}
                <small>({props.currentKund.Orgnr})</small></Typography>
            </Grid>          
            <Grid sm="2"><Typography>Adress:</Typography></Grid>      
            <Grid sm="10">
                <Typography>{props.currentKund.Adress} 
                <small> {props.currentKund.Postnr} {props.currentKund.Ort} </small></Typography>
            </Grid>
        </Grid>
    );
}

export default Kund;